/* src/app/components/cbm-rating/cbm-rating.component.scss */
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
.title {
  font-family: "Gotham-Book", serif;
  font-size: 18px;
  color: #333333;
  padding-bottom: 10px;
  white-space: pre-wrap;
  width: 530px;
}
.icon-set {
  width: 300px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: #9A9B9C;
  font-family: "Helvetica Neue", serif;
}
.icon-set p {
  display: block;
}
.rate-icon,
.star-active,
.star-inactive {
  width: 51px;
  height: 48px;
  cursor: pointer;
  outline: none;
  background-size: cover;
}
.star-inactive {
  background-image: url(/assets/img/icons/cb_star_inactive.svg);
}
.star-active {
  background-image: url(/assets/img/icons/cb_star_active.svg);
}
@media screen and (max-width: 1000px) {
  .rate-icon,
  .star-inactive,
  .star-active {
    width: 35px;
    height: 35px;
    margin: 2px;
  }
  .icon-set {
    width: 100%;
    justify-content: unset;
  }
  .title {
    width: 275px;
  }
}
/*# sourceMappingURL=cbm-rating.component.css.map */
